import {
  normalizeCountryCode,
  resolveMappedLanguageFromCountryCode,
} from './country-map';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from './types';

export type MessageLanguageSource =
  | 'template'
  | 'account'
  | 'country'
  | 'default';

export interface MessageLanguageAccount {
  messageLanguage?: string | null;
  defaultCountryCode?: string | null;
}

export interface ResolvedMessageLanguage {
  language: SupportedLanguage;
  source: MessageLanguageSource;
}

export function isSupportedLanguage(
  value: string | null | undefined,
): value is SupportedLanguage {
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(value ?? '');
}

/**
 * A well-formed country with no mapped language (US, CA) still reports
 * `country`: the account has a country and English is what it implies.
 */
export function resolveMessageLanguage(
  { messageLanguage, defaultCountryCode }: MessageLanguageAccount,
  templateLanguage?: string | null,
): ResolvedMessageLanguage {
  if (isSupportedLanguage(templateLanguage)) {
    return { language: templateLanguage, source: 'template' };
  }
  if (isSupportedLanguage(messageLanguage)) {
    return { language: messageLanguage, source: 'account' };
  }
  if (normalizeCountryCode(defaultCountryCode) !== null) {
    const language =
      resolveMappedLanguageFromCountryCode(defaultCountryCode) ?? 'en';
    return { language, source: 'country' };
  }
  return { language: 'en', source: 'default' };
}
